import { ActionTypes } from "../constants/action-types";

export const setEncouragementEventPopoverIds = (map: { [event: string]: string[] }) => ({
    type: ActionTypes.SET_ENCOURAGEMENT_EVENT_POPOVER_IDS,
    payload: map,
});

export const setEncouragementShown = (popoverId: string) => ({
    type: ActionTypes.SET_ENCOURAGEMENT_SHOWN,
    payload: popoverId,
});

export const setEncouragementShownBulk = (shownMap: { [key: string]: boolean }) => ({
    type: ActionTypes.SET_ENCOURAGEMENT_SHOWN_BULK,
    payload: shownMap,
});

export const resetEncouragement = () => ({
    type: ActionTypes.RESET_ENCOURAGEMENT,
    payload: null,
});
